import React, { useCallback, useContext } from 'react';
import get from 'lodash/get';
import map from 'lodash/map';
import set from 'lodash/set';

import {
  ContainerForOptions,
  OptionContainer,
  Row,
  StyledTextarea,
} from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import InputField from 'src/presentation/components/forms/InputField';
import useOptionsGeneratedIds from 'src/presentation/components/pages/ivr/hooks/useOptionsGeneratedIds';

import FormContext from 'src/presentation/contexts/FormContext';

const VARIABLE_ATTR = 'variables';

const HttpNodeVariables = ({ attr, disabled, readOnly }) => {
  const { updateState, workingState } = useContext(FormContext);

  const variables = get(workingState, `${attr}.${VARIABLE_ATTR}`, []);

  const { addOptionId, optionsIds, removeOptionIdByIndex } = useOptionsGeneratedIds(variables);

  const onAddButtonClick = useCallback(() => {
    const withNewMenuItem = [
      ...variables,
      {
        name: '',
        expression: '',
      },
    ];
    updateState(set({}, `${attr}.${VARIABLE_ATTR}`, withNewMenuItem));
    addOptionId();
  }, [attr, variables, updateState, addOptionId]);

  return (
    <ContainerForOptions
      addButtonLabel="Add Variable"
      onAddButtonClick={onAddButtonClick}
      disabled={disabled || readOnly}
      label="Saved Response Variables"
      context={map(variables, (_, idx) => {
        return (
          <HeaderValue
            attr={attr}
            index={idx}
            key={optionsIds[idx] || idx}
            disabled={disabled}
            readOnly={readOnly}
            removeOptionIdByIndex={removeOptionIdByIndex}
          />
        );
      })}
    ></ContainerForOptions>
  );
};

const HeaderValue = ({ attr, index, disabled, readOnly, removeOptionIdByIndex }) => {
  const baseAttr = `${attr}.${VARIABLE_ATTR}[${index}]`;
  const baseDataAid = `${VARIABLE_ATTR}[${index}]`;
  return (
    <OptionContainer
      attrList={`${attr}.${VARIABLE_ATTR}`}
      currentIndex={index}
      removeOptionIdByIndex={removeOptionIdByIndex}
      data-aid={baseDataAid}
      disabled={disabled}
      readOnly={readOnly}
    >
      <Row>
        <InputField
          attr={`${baseAttr}.name`}
          data-aid={`${baseDataAid}.name`}
          description="The name of the variable we are pulling (must be alphanumeric)"
          disabled={disabled}
          label="Variable Name"
          readOnly={readOnly}
        />
      </Row>

      <Row>
        <StyledTextarea
          attr={`${baseAttr}.expression`}
          data-aid={`${baseDataAid}.expression`}
          description="When the body is of type application/json then the expression MUST be a template definition. When it is of type text/* then the expression MUST be a regular expression"
          disabled={disabled}
          label="Expression"
          readOnly={readOnly}
        />
      </Row>
    </OptionContainer>
  );
};

export default HttpNodeVariables;
